import React, { useState } from "react";
import Style from "./ChangeDetailProduct.module.css";
import { separate } from "../../Functions/NumberSeprator";
import toEnglishDigits from "../../Functions/PersionToEn";
import { CheckLg, XLg, Tag, BoxSeam, InfoCircle } from "react-bootstrap-icons";

const ChangeDetailProduct = ({ handleClose, rawInfo, sendData }) => {
  // Normalize initial availability (1: available, 0: unavailable)
  const initialAvailability =
    rawInfo?.available === "1" ||
    rawInfo?.available === 1 ||
    rawInfo?.available === true
      ? "1"
      : "0";

  const [availability, setAvailability] = useState(initialAvailability);

  // Normalize initial price (strip commas if any)
  const initialPriceStr = String(rawInfo?.rawPrice ?? rawInfo?.price ?? "").replace(/,/g, "");
  const [priceInput, setPriceInput] = useState(initialPriceStr);

  // Normalize initial count
  const initialCount = Number(rawInfo?.newCount ?? rawInfo?.count ?? 1);
  const [count, setCount] = useState(initialCount);

  // Format price input with live commas
  const handlePriceChange = (e) => {
    const rawVal = toEnglishDigits(e.target.value).replace(/[^0-9]/g, "");
    setPriceInput(rawVal);
  };

  const handleCountChange = (val) => {
    const nextVal = Math.max(0, Number(val) || 0);
    setCount(nextVal);
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const cleanPrice =
      priceInput !== "" ? Number(priceInput) : Number(initialPriceStr) || 0;
    const cleanCount = count !== "" ? Number(count) : initialCount;

    sendData({
      product_id: rawInfo.id,
      p_product_id:
        rawInfo.pProductId === "0" || !rawInfo.pProductId
          ? 0
          : Number(rawInfo.pProductId),
      new_price: cleanPrice,
      new_count: cleanCount,
      availability: availability,
    });
    handleClose();
  };

  return (
    <div className={Style.wrapper}>
      {/* Product Information Card */}
      <div className={Style.productInfoCard}>
        <div className={Style.productHeader}>
          <BoxSeam className={Style.productIcon} />
          <div className={Style.productTextGroup}>
            <span className={Style.productLabel}>نام محصول</span>
            <h4 className={Style.productName}>{rawInfo?.name || "بدون نام"}</h4>
          </div>
        </div>

        <div className={Style.currentStats}>
          <div className={Style.statPill}>
            <span className={Style.statTitle}>تعداد فعلی:</span>
            <span className={Style.statValue}>{rawInfo?.count || 0} عدد</span>
          </div>
          <div className={Style.statPill}>
            <span className={Style.statTitle}>قیمت فعلی:</span>
            <span className={Style.statValue}>
              {separate(rawInfo?.rawPrice || rawInfo?.price || 0)} تومان
            </span>
          </div>
        </div>
      </div>

      <form onSubmit={handleSubmit} className={Style.form}>
        {/* Availability Toggle */}
        <div className={Style.fieldGroup}>
          <label className={Style.label}>
            <span>وضعیت موجودی در فاکتور</span>
          </label>
          <div className={Style.availabilityGroup}>
            <button
              type="button"
              className={`${Style.availBtn} ${
                availability === "1" ? Style.availActive : ""
              }`}
              onClick={() => setAvailability("1")}
            >
              <CheckLg />
              <span>موجود</span>
            </button>
            <button
              type="button"
              className={`${Style.availBtn} ${
                availability === "0" ? Style.unavailActive : ""
              }`}
              onClick={() => setAvailability("0")}
            >
              <XLg />
              <span>ناموجود</span>
            </button>
          </div>
        </div>

        {/* New Price Field */}
        <div className={Style.fieldGroup}>
          <label className={Style.label} htmlFor="changeDetailPrice">
            <span>قیمت جدید</span>
            <span className={Style.unitHint}>
              {priceInput ? `${separate(priceInput)} تومان` : "به تومان"}
            </span>
          </label>
          <div className={Style.inputWrapper}>
            <Tag className={Style.inputIcon} />
            <input
              id="changeDetailPrice"
              type="text"
              inputMode="numeric"
              className={Style.input}
              placeholder="قیمت جدید را وارد کنید..."
              value={priceInput ? separate(priceInput) : ""}
              onChange={handlePriceChange}
              autoComplete="off"
            />
          </div>
        </div>

        {/* New Count Field */}
        <div className={Style.fieldGroup}>
          <label className={Style.label} htmlFor="changeDetailCount">
            <span>تعداد جدید</span>
            <span className={Style.unitHint}>عدد</span>
          </label>
          <div className={Style.countControl}>
            <button
              type="button"
              className={Style.counterBtn}
              onClick={() => handleCountChange(count + 1)}
              aria-label="افزایش تعداد"
            >
              +
            </button>
            <input
              id="changeDetailCount"
              type="number"
              min="0"
              className={Style.countInput}
              value={count}
              onChange={(e) => handleCountChange(toEnglishDigits(e.target.value))}
            />
            <button
              type="button"
              className={Style.counterBtn}
              onClick={() => handleCountChange(Math.max(0, count - 1))}
              aria-label="کاهش تعداد"
            >
              -
            </button>
          </div>
        </div>

        {availability === "0" && (
          <div className={Style.noticeBox}>
            <InfoCircle />
            <span>با انتخاب حالت «ناموجود»، این کالا در فاکتور نهایی خط خواهد خورد.</span>
          </div>
        )}

        {/* Modal Action Buttons */}
        <div className={Style.actions}>
          <button type="submit" className={Style.submitBtn}>
            ثبت تغییرات
          </button>
          <button
            type="button"
            className={Style.cancelBtn}
            onClick={handleClose}
          >
            انصراف
          </button>
        </div>
      </form>
    </div>
  );
};

export default ChangeDetailProduct;
